import {
  BASE,
  CLASS_HOLDER_CORE_SELECTION,
  CLASS_HOLDER_FINISHING_GUIDE,
  CLASS_ITEM_CORE_SELECTION,
  CLASS_ITEM_FINISHING_GUIDE,
} from "./constants";
import { AppVariantType, APP_VARIANTS_ENUM } from "../models/appSettings";

export function toogleCheckboxCheckClassName(
  data: string[],
  variantId: number
) {
  return data.includes(variantId.toString())
    ? "fas fa-check-square"
    : "far fa-square";
}

export function toggleVisibility(ev, selector = "") {
  const { target } = ev;
  if (selector) {
    target.closest(selector).classList.toggle(BASE.activeClass);
  } else {
    target.parentNode.classList.toggle(BASE.activeClass);
  }
}

export function classNamesBasedOnAppVariant(appVariant: AppVariantType) {
  if (appVariant === APP_VARIANTS_ENUM.CORE_SELECTION) {
    return {
      CLASS_HOLDER: CLASS_HOLDER_CORE_SELECTION,
      CLASS_ITEM: CLASS_ITEM_CORE_SELECTION,
    };
  } else if (appVariant === APP_VARIANTS_ENUM.FINISHING_GUIDE) {
    return {
      CLASS_HOLDER: CLASS_HOLDER_FINISHING_GUIDE,
      CLASS_ITEM: CLASS_ITEM_FINISHING_GUIDE,
    };
  }
}
